/**
 * Legacy-Layout (jQuery imageScroll, matchHeight, bootsnav) nach dynamischen
 * Inhaltsänderungen aktualisieren – ohne synthetische scroll-Events auf window,
 * die fehlerhafte Browser-Extensions triggern können.
 */
import { refreshAllPricingHeights } from './pricingHeights.js'
import { isMobileViewport } from './viewport.js'

export function refreshParallaxImages() {
  if (typeof window === 'undefined' || typeof window.$ === 'undefined') return
  if (isMobileViewport()) return

  window.$('.img-holder').each(function refreshHolder() {
    const $holder = window.$(this)
    if (!$holder.data('plugin_imageScroll')) return

    try {
      $holder.imageScroll('refresh')
    } catch (_) {
      /* Plugin noch nicht bereit */
    }
  })
}

export function refreshLegacyLayout() {
  refreshParallaxImages()
  refreshAllPricingHeights()

  if (typeof window !== 'undefined' && typeof window.$ !== 'undefined') {
    window.$(window).trigger('resize')
  } else if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('resize'))
  }
}
